module.exports = __webpack_public_path__ + "static/headshot-milan-shah-3x.17f651be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-milan-shah-3x.jpg
// module id = 529
// module chunks = 152909308826437